'use client'

import { useMediaQuery } from '@patrianna/shared-hooks'

import BackButtonLink from 'src/components/BackButtonLink'
import BuilderTextContent from 'src/components/BuilderTextContent'
import useBackUrl from 'src/hooks/useBackUrl'

import type { BuilderContent } from 'app/utils/builder'

export default function AboutUs(props: { content: BuilderContent | null; builderPage: string; backHref?: string }) {
  const backUrl = useBackUrl({ backHref: props.backHref })
  const isMobile = useMediaQuery('xs')

  return (
    <>
      {isMobile && <BackButtonLink href={backUrl} />}
      <BuilderTextContent content={props.content} model={props.builderPage} />
    </>
  )
}
